import { API_BASE } from "@/lib/api";

/** Client account batch tags — synced with backend/app/account_groups.py */
export const PRESET_ACCOUNT_GROUPS = [
  { name: "JVM001", color: "#3B82F6" },
  { name: "ASM001", color: "#10B981" },
  { name: "ARC001", color: "#8B5CF6" },
  { name: "DC001", color: "#F59E0B" },
  { name: "PC001", color: "#EC4899" },
  { name: "MISC1", color: "#64748B" },
];

export function contrastTextOn(hex) {
  const c = (hex || "#64748B").replace("#", "");
  if (c.length !== 6) return "#ffffff";
  const r = parseInt(c.slice(0, 2), 16);
  const g = parseInt(c.slice(2, 4), 16);
  const b = parseInt(c.slice(4, 6), 16);
  const luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255;
  return luminance > 0.58 ? "#101010" : "#ffffff";
}

/** Solid filled badge — high visibility */
export function groupBadgeStyle(color) {
  const c = color || "#64748B";
  return {
    backgroundColor: c,
    borderColor: c,
    color: contrastTextOn(c),
  };
}

/** Subtle tint for dropdown options / unselected states */
export function groupStyle(color) {
  const c = color || "#64748B";
  return {
    backgroundColor: `${c}22`,
    borderColor: `${c}88`,
    color: c,
  };
}

export function groupColor(name, groups = PRESET_ACCOUNT_GROUPS) {
  return groups.find((g) => g.name === name)?.color;
}

export async function downloadReport(scope) {
  const token = localStorage.getItem("mt5_token");
  const res = await fetch(`${API_BASE}/reports/export?scope=${scope}`, {
    credentials: "include",
    headers: token ? { Authorization: `Bearer ${token}` } : {},
  });
  if (!res.ok) throw new Error("Export failed");
  const blob = await res.blob();
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = res.headers.get("Content-Disposition")?.match(/filename="(.+)"/)?.[1]
    || `mt5hub-${scope}.xlsx`;
  a.click();
  URL.revokeObjectURL(url);
}
